import common from '@/router/paths/common'
import engineers from '@/router/paths/engineers'
import tenants from '@/router/paths/tenants'
import vendors from '@/router/paths/vendors'

const subSections = [vendors, tenants, engineers, common]

const paths = subSections.reduce((path, sec) => {
  sec.paths.routes.forEach((route) => {
    if (sec.prefix) {
      route.path = sec.prefix + route.path
    }
    if (sec.userTypeAcl) {
      route.meta = {
        userTypeAcl: sec.userTypeAcl,
        ...route.meta,
      }
    }
    route.meta = {
      ...route.meta,
    }
  })
  path = {
    mode: 'history',
    routes: [
      ...path.routes,
      ...sec.paths.routes,
    ],
  }
  return path
}, { routes: [] })

export default paths
